let helper = require('./../helper');

function showModalIfNoSpaceInProperty(propertyId, countSelectedGuardians)
{
    $.ajax({
        url: helper.getOrigin() + '/api/properties/' + propertyId + '/validateSpace',
        method: 'GET',
        data: { guardiansNumber: countSelectedGuardians },
    }).done(function (response) {
        if (response) {
            var swal = require('sweetalert2');

            swal({
                title: "Guardian living space has been exceed, is this information correct ?",
                type: "warning",
            })
        }
    });
}

function numberOfSpecesInRoom(roomId, spaces)
{
    $.ajax({
        url: helper.getOrigin() + '/api/rooms/' + roomId + '/validateSpace',
        method: 'GET',
        async: false,
        dataType: 'json',
        success: function (response) {
            spaces = response.count;
        }
    });

    return spaces;
}

function getPriceOfSelectedRoom(roomId, roomPrice)
{
    $.ajax({
        url: helper.getOrigin() + '/api/rooms/' + roomId + '/getPrice',
        method: 'GET',
        async: false,
        dataType: 'json',
        success: function (response) {
            roomPrice = response.price;
        }
    });

    return roomPrice;
}

function getOldRentsOfGuardian(selectedGuardians, oldRentsData)
{
    $.ajax({
        url: helper.getOrigin() + '/api/guardians/getCurrentRents',
        method: 'GET',
        async: false,
        dataType: 'json',
        data: { selectedGuardians: selectedGuardians },
        success: function (response) {
            oldRentsData = response;
        }
    });

    return oldRentsData;
}

function assignGuardians(guardians, selectedGuardians)
{
    guardians.each(function () {
        let value = $(this).val();

        if ($.inArray(value, selectedGuardians) < 0) {
            selectedGuardians.push(value);
        }
    });

    return selectedGuardians;
}

export { showModalIfNoSpaceInProperty, numberOfSpecesInRoom, assignGuardians, getOldRentsOfGuardian, getPriceOfSelectedRoom }
